import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import { memoryStorage } from '../storage/memoryStorage';
import { authActions } from './actions';
import { initialState, reducer } from './reducer';
import { authenticate } from './authenticate';
export var AuthStateContext = createContext(undefined);
export var AuthDispatchContext = createContext(undefined);

var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children,
      authenticators = _ref.authenticators,
      _ref$storage = _ref.storage,
      storage = _ref$storage === void 0 ? memoryStorage() : _ref$storage,
      noInit = _ref.noInit,
      seed = _objectWithoutPropertiesLoose(_ref, ["children", "authenticators", "storage", "noInit"]);

  var hasDefaultCredential = Boolean(seed.credential);

  var _init = noInit ? false : !hasDefaultCredential;

  var _useReducer = useReducer(reducer, _extends({}, initialState, {
    isGuestModeEnabled: Boolean(seed.guestMode),
    credential: seed.credential,
    isAuthenticated: hasDefaultCredential,
    isLoading: _init
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var credential = state.credential,
      isLoading = state.isLoading;

  if (process.env.NODE_ENV !== 'test') {
    var originalStore = storage.store;

    storage.store = function (credential, update) {
      return Promise.resolve(originalStore(credential)).then(function () {
        if (update) {
          dispatch(authActions.setCredential(credential));
        }
      });
    };
  }

  var auth = useMemo(function () {
    return Array.isArray(authenticators) ? authenticators : [authenticators];
  }, [authenticators]);
  var isGuest = useMemo(function () {
    return credential ? Boolean(credential.user.isGuest) : false;
  }, [credential]);
  useEffect(function () {
    var mounted = true;

    if (mounted && !isGuest && !isLoading) {
      storage.store(credential);
    }

    return function () {
      mounted = false;
    };
  }, [credential, isGuest, isLoading, storage]);
  useEffect(function () {
    var mounted = true;

    if (isLoading) {
      authenticate(storage, auth).then(function (result) {
        return mounted && dispatch(authActions.auth.success(result));
      }).catch(function (err) {
        return mounted && dispatch(authActions.auth.failure(err));
      });
    }

    return function () {
      mounted = false;
    };
  }, [isLoading]);
  return React.createElement(AuthDispatchContext.Provider, {
    value: dispatch
  }, React.createElement(AuthStateContext.Provider, {
    value: state
  }, children));
};

AuthProvider.defaultProps = {
  authenticators: []
};
export { AuthProvider };